import React from "react";

import { Container } from "./styles";

const TagStatus = ({ children, ...otherProps }) => (
  <Container {...otherProps}>{children}</Container>
);

const TagStatusInactive = ({ children, ...otherProps }) => (
  <TagStatus
    className="status"
    background="#FBC7C7"
    borderColor="#D44C4C"
    color="#D44C4C"
  >
    {children}
  </TagStatus>
);

const TagStatusActive = ({ children, ...otherProps }) => (
  <TagStatus
    className="status"
    background="#C7FBC7"
    borderColor="#4CD44C"
    color="#4CD44C"
  >
    {children}
  </TagStatus>
);

export { TagStatusInactive, TagStatusActive };
export default TagStatus;
